import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';

@Component({
  selector: 'app-questions-thumb-card',
  templateUrl: './questions-thumb-card.component.html',
  styleUrls: ['./questions-thumb-card.component.css']
})
export class QuestionsThumbCardComponent implements OnInit {

  @Input() cardID: number;
  @Input() cardTitle: any;
  @Input() questionData: any = [];
  @Input() isFromMyLibrary:any;
  @Input() isFromMyHistory:any;
  noOfViews: any;
  constructor(public selfLearnService: SelfLearnService, public router: Router) { }

  ngOnInit(): void {
    console.log(this.questionData.qbdata);
    this.noOfViews = this.getNoOfViews();
  }

  displayTime(duration: any) {
    return this.selfLearnService.secondsToTime(duration);
  }

  getNoOfViews() {
    return this.selfLearnService.generateRandomNumber();
  }

  displayImage(url: any) {
    
    return url?.replaceAll('https', 'http');
  }
  navigateToPracticetest() {
    //localStorage.setItem('subtopicCount', topicData.subtopicCount);
    localStorage.setItem("selfLearnSelectedSubject",this.questionData.subjectId);
    localStorage.setItem('selfLearnSelectedSubjectName',this.questionData.nodeName);
    localStorage.setItem("chapterId",this.questionData.chapterId);
    localStorage.setItem("chapterName",this.questionData.chapterName);
    localStorage.setItem("selfLearnSelectedTopicId", this.questionData.topicId);
    localStorage.setItem("selfLearnSelectedTopicName", this.questionData.topicName);
    localStorage.setItem('isFromHomeScreen','true');
    localStorage.setItem('previousScreen', !this.isFromMyLibrary ?this.isFromMyHistory ? 'selfLearn-V2/my-history' :'selfLearn-V2/bookmarks': 'selfLearn-V2/my-library')
    // localStorage.setItem('currentLevel', topicData.levelsInProgress);
    // if(topicData.levelsCompleted == 4){this.router.navigate([`selfLearn-V2/practice-completion`]);}
    this.router.navigate([`selfLearn-V2/practice-questions`]);

  }
}
